"use client"

import { useSession } from "next-auth/react"
import { useEffect } from "react"
import { useRouter } from "next/navigation"
import AppFrame from "./components/AppFrame"
import LoadingScreen from "./components/common/LoadingScreen"

export default function Home() {
  const { data: session, status } = useSession()
  const router = useRouter()

  // Check if user is logged in
  useEffect(() => {
    if (status === "unauthenticated") {
      console.log("User not authenticated. Redirecting to login page.")
      router.push("/logout")
      return
    }

    if (status === "authenticated") {
      const storeUser = async () => {
        try {
          const response = await fetch("/api/auth/loggedIn", {
            method: "POST",
            credentials: "include", // Include cookies
          })

          if (!response.ok) {
            console.error(
              "Failed to store user:",
              response.status,
              response.statusText
            )
          }
        } catch (error) {
          console.error("Error storing user:", error)
        }
      }
      storeUser()
    }
    status === "authenticated"
      ? console.log(
          `Session ${status} for ${session?.user?.email} expires in ${
            session?.expires
              ? Math.ceil(
                  (new Date(session.expires).getTime() - new Date().getTime()) /
                    (1000 * 60 * 60 * 24)
                )
              : "unknown"
          } days.`
        )
      : status === "loading"
      ? null
      : console.log(`Session ${status}`)
  }, [status, session])

  if (status === "loading") {
    return <LoadingScreen />
  }

  return <AppFrame />
}
